export const PENDING_AUTH_RESULT_KEY = "oauth_pending_result";
export const PENDING_AUTH_RESULT_MAX_AGE_MS = 2 * 60 * 1000;

const OAUTH_STORAGE_KEYS = [
  "oauth_state",
  "oauth_code_verifier",
  "oauth_gitlab_base_url",
  "oauth_intent",
  "oauth_access_token_gitlab",
  "oauth_access_token_github",
  PENDING_AUTH_RESULT_KEY,
] as const;

export const ADD_PROVIDER_ORIGIN_KEY = "oauth_add_provider_origin";

export function clearOAuthClientState(options: { keepAddProviderOrigin?: boolean } = {}): void {
  for (const key of OAUTH_STORAGE_KEYS) {
    sessionStorage.removeItem(key);
  }
  if (!options.keepAddProviderOrigin) {
    sessionStorage.removeItem(ADD_PROVIDER_ORIGIN_KEY);
  }
}

export function isFreshPendingAuthResult(now = Date.now()): boolean {
  const raw = sessionStorage.getItem(PENDING_AUTH_RESULT_KEY);
  if (!raw) return false;
  try {
    const parsed = JSON.parse(raw) as { completedAt?: unknown };
    if (typeof parsed.completedAt !== "number" || !Number.isFinite(parsed.completedAt)) {
      return false;
    }
    const age = now - parsed.completedAt;
    return age >= 0 && age <= PENDING_AUTH_RESULT_MAX_AGE_MS;
  } catch {
    return false;
  }
}

export function isCompletingOAuthRedirect(search: string, now = Date.now()): boolean {
  return new URLSearchParams(search).get("oauth") === "complete" && isFreshPendingAuthResult(now);
}

export async function cancelPendingAccountLink(): Promise<void> {
  await fetch("/api/auth/link/cancel", {
    method: "POST",
    credentials: "include",
  }).catch(() => undefined);
}

export async function clearServerAuthCookie(): Promise<void> {
  await fetch("/api/auth/logout", {
    method: "POST",
    credentials: "include",
  }).catch(() => undefined);
}

export async function clearStaleAuthState(
  options: {
    keepAddProviderOrigin?: boolean;
    cancelPendingLink?: boolean;
    expireServerSession?: boolean;
  } = {}
): Promise<void> {
  clearOAuthClientState({ keepAddProviderOrigin: options.keepAddProviderOrigin });
  if (options.expireServerSession) {
    await clearServerAuthCookie();
  }
  if (options.cancelPendingLink) {
    await cancelPendingAccountLink();
  }
}
